import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const STORE_QINETIC_PS_API_NAME: string = 'store_qinetic_ps';
export const STORE_QINETIC_PS_API_ENDPOINT: string = environment.API_BASE_PATH + '/store-qinetic-payment-source';

@Injectable({
  providedIn: 'root',
})
export class StoreQineticPaymentSourceService {
  listStoreQineticPaymentSources(company_id: string, store_id: string): Observable<any> {
    const api_name: string = STORE_QINETIC_PS_API_NAME;
    const path: string = `/company/${company_id}/store/${store_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }
}

export class StoreQineticPaymentSource {
  store_qinetic_payment_source_id?: string;
  object?: string;
  company_id?: string;
  store_id?: string;
  holder_fullname?: string;
  holder_email?: string;
  iban?: string;
  country?: string;
  is_default_source?: boolean;
}
